import { ProjectStackDocument } from '~/src/entities/project';

export const getDocumentsForFields = (
  fields: string[],
  documents: ProjectStackDocument[],
) =>
  documents.filter(({ document_fields }) =>
    fields.some((f) => f in document_fields),
  );
